import Foodcart2 from 'components/Foodcart2';
import React from 'react';
import styled from 'styled-components';

const Order = () => {
    return (
        <Container>
            <Foodcart2 />
        </Container>
    );
};

export default Order;

const Container = styled.div`

`
